import { selectChangeMessageForThemes } from '@UI/aside/asideThemes/AsideThemesSelectors';
import { type ContentHref, ContentType } from '@generalTypes/apiTypes';
import { selectEmptyThemesRule } from '@newStore/validation/validationRules/notEmptyThemesValidationRules';
import type { EditAsideThemes } from '@nodeTypeConfig/configTypes';
import { dienstverleningKovKey } from '@store/constants/constants';

export const leerplanSitesThemeComponent: EditAsideThemes = {
  component: 'themes',
  property: 'themes',
  reactComponent: 'AsideThemes',
  label: "Leerplanthema's",
  options: {
    referenceFrameHref: `/content/${dienstverleningKovKey}` as ContentHref,
    types: [ContentType.THEME, ContentType.CURRICULUM_THEME],
    highlightOldCurrItems: true,
  },
  asideChangeMessageSelector: selectChangeMessageForThemes,
  validations: [selectEmptyThemesRule],
};
